import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/projectStyles/Projects.css";
import { useNavigate } from "react-router-dom";
import Header from "../../components/HeaderFooter/Header";
import Footer from "../../components/HeaderFooter/Footer";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { fetchProjectDetails } from "../../services/API";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/projectStyles/Projects.css";

const Projects = () => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const timezoneToUse = "UTC";
  const [activeTab, setActiveTab] = useState("Today");
  const [selectedDate, setSelectedDate] = useState([null, null]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(7);
  const [projectData, setProjectData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  //for getting unique tasks for filter
  const [taskOptions, setTaskOptions] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  //for getting unique employee for filter
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  //for getting unique project name for filter
  const [selectedProjectName, setSelectedProjectName] = useState(null);
  const [projectOptions, setProjectOptions] = useState([]);


  const [dropdownState, setDropdownState] = useState({
    projectOpen: false,
    tasksOpen: false,
    teamOpen: false,
    dateOpen: false,
  });

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch and transform project data from API
    const getProjectData = async () => {
      try {
        const response = await fetchProjectDetails();
        const transformedData = response.data.map((project) => {
          const projectId = project.projectData.Project_ID;
          const projectName = project.projectData.Address;

          // Parse the start and end dates in UTC
          const startDate = dayjs.utc(project.Timeframe[0]["MIN(Time_Start)"]).tz(timezoneToUse);
          const endDate = dayjs.utc(project.Timeframe[0]["MAX(Time_Finish)"]).tz(timezoneToUse);

          // Check if the dates fall on the same day
          const isSameDay = startDate.isSame(endDate, "day");

          // Format the start and end dates for display (without year)
          const startDateDisplay = startDate.format("DD MMM");
          const endDateDisplay = endDate.format("DD MMM YYYY");

          // Format the start date
          const formattedStartDate = startDate.format("DD MMM YYYY");

          // Format the end date if it's not the same day
          const formattedEndDate = isSameDay ? "" : ` - ${endDate.format("DD MMM YYYY")}`;

          // Format the time from the start date
          const time = startDate.format("h:mm A");

          // Combine the date range and time
          const dateRange = `${startDateDisplay} - ${endDateDisplay}`;
          // console.log(dateRange);

          // Extract unique employees from Tasks
          const employees = project.Tasks.flatMap((task) => task.Employees.map((employee) => employee.Employee_Name));

          // Get the first main task
          const mainTask = project.Tasks.length > 0 ? project.Tasks[0].Task_Name: "No Task Assigned";

          return { projectId, projectName, dateRange, employees, time, mainTask, formattedStartDate, formattedEndDate};
        });

        setProjectData(transformedData);

// Filter unique project names based on active tab
const today = new Date();
const filteredProjects = transformedData.filter((project) => {
  const startDate = new Date(project.formattedStartDate);
  const endDate = new Date(project.formattedEndDate);

  if (
    (activeTab === "Today" &&
      startDate <= today &&
      endDate >= today) ||
    (activeTab === "Upcoming" && startDate > today) ||
    (activeTab === "Past" && endDate < today)
  ) {
    return true;
  }
  return false;
});


        //trying to access unique tasks from existing project
        const uniqueTasks = [
          ...new Set(
            transformedData
              .map((project) => project.mainTask)
              .filter((task) => task !== "No Task Assigned")
          ),
        ];
        setTaskOptions(uniqueTasks);

        // Extract unique employees
        const uniqueEmployees = [
          ...new Set(transformedData.flatMap((project) => project.employees || [])),
        ];
        setEmployeeOptions(uniqueEmployees);

        const uniqueProjectNames = [
          ...new Set(filteredProjects.map((project) => project.projectName)),
        ];
        setProjectOptions(uniqueProjectNames);

        console.log("uniqueProjectNames = ", uniqueProjectNames)

      } catch (error) {
        console.error("Error fetching project data:", error);
      }
    };

    getProjectData();
  }, [activeTab]);

  const toggleDropdown = (dropdownName) => {
    setDropdownState((prevState) => ({
      ...prevState,
      projectOpen: false,
      tasksOpen: false,
      teamOpen: false,
      dateOpen: false,
      [dropdownName]: !prevState[dropdownName],
    }));
  };

  const handleNewProjectClick = () => {
    const pd = Boolean(localStorage.getItem("projectId"));
    if (pd) {
      localStorage.removeItem("projectDescription");
      localStorage.removeItem("selectedTasks");
      localStorage.removeItem("dateRanges");
      localStorage.removeItem("uploadedFiles");
      localStorage.removeItem("projectId");
    }
    navigate("/addproject");
  };

  const handleProjectDetailsClick = (projectId) => {
    navigate(`/projectdetails/${projectId}`);
  };

  //filter projects
  const filteredProjects = projectData.filter((project) => {

    const matchesSearch = project.projectName.toLowerCase().includes(searchQuery.toLowerCase());
    const today = new Date();
    const startDate = new Date(project.formattedStartDate); 
    const endDate =  new Date(project.formattedEndDate);
    
    // console.log("Today", today, " Start date ", startDate, " End date", endDate);

    const matchesTab = (activeTab === "Today" && startDate <= today && endDate >= today) || 
      (activeTab === "Upcoming" && startDate > today) ||
      (activeTab === "Past" && endDate < today);

    const matchesTask = !selectedTask || project.mainTask === selectedTask;
    const matchesEmployee = !selectedEmployee || project.employees.includes(selectedEmployee);
    const matchesProjectName = !selectedProjectName || project.projectName === selectedProjectName;

    const matchesDateRange =  (!selectedDate[0] || new Date(project.formattedStartDate) <= selectedDate[1]) &&
                              (!selectedDate[1] || new Date(project.formattedEndDate) >= selectedDate[0]);

    return matchesSearch && matchesTab && matchesTask && matchesEmployee && matchesDateRange && matchesProjectName;
    
  });

  // Pagination Logic
  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setCurrentPage(1); 
  };

  const currentProjects = filteredProjects.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="projects-container">
      <Header />
      
      <div className="content">
        <div className="tabs-container">
          <h2 className="tabs-title">Projects</h2>
          <div className="tabs">
            <button className={`tab-item ${activeTab === "Today" ? "active" : ""}`} onClick={() => handleTabClick("Today")}>Today </button>
            <button className={`tab-item ${activeTab === "Upcoming" ? "active" : ""}`} onClick={() => handleTabClick("Upcoming")} >Upcoming</button>
            <button className={`tab-item ${activeTab === "Past" ? "active" : ""}`} onClick={() => handleTabClick("Past")}>Past</button>
          </div>
        </div>
      
      </div>

      <div className="projectScreen">
        <div className="project-filter-container">
          <div className="filter-title">Filters</div>

            <div className="filter-section">
              <button onClick={() => toggleDropdown("projectOpen")} className={`filter-btn ${ dropdownState.projectOpen ? "open" : "" }`} >
                Project Name
              </button> 
              
              {dropdownState.projectOpen && (
                <div className="filter-dropdown">
                  {projectOptions.map((projectName, index) => (
                    <span
                      key={index}
                      className={selectedProjectName === projectName ? "selected-project" : "unselected-project" }
                      onClick={() => {
                        if (selectedProjectName === projectName) {
                          setSelectedProjectName(null); // Deselect project name
                        } else {
                          setSelectedProjectName(projectName); // Select project name
                        }
                      }}
                    >
                      {projectName}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="filter-section">
              <button onClick={() => toggleDropdown("tasksOpen")} className={`filter-btn ${dropdownState.tasksOpen ? "open" : ""}`} >
                Tasks
              </button>
              {dropdownState.tasksOpen && (
                <div className="filter-dropdown">
                  {taskOptions.map((task, index) => (
                    <span key={index}
                      className={selectedTask === task ? "selected-task" : "unselected-task"} // Highlight selected task
                      onClick={() => {
                        if (selectedTask === task) {
                          setSelectedTask(null); // Deselect task on second click
                        } else {
                          setSelectedTask(task); // Select task
                        }
                      }}
                    >
                      {task}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="filter-section">
              <button
                onClick={() => toggleDropdown("teamOpen")}
                className={`filter-btn ${dropdownState.teamOpen ? "open" : ""}`}
              >
                Team
              </button>
              {dropdownState.teamOpen && (
                <div className="filter-dropdown">
                  {employeeOptions.map((employee, index) => (
                    <span
                      key={index} className={selectedEmployee === employee ? "selected-employee" : "unselected-employee"} 
                      onClick={() => {
                        if (selectedEmployee === employee) {
                          setSelectedEmployee(null); 
                        } else {
                          setSelectedEmployee(employee); 
                        }
                      }}
                    >
                      {employee}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="filter-section">
              <button onClick={() => toggleDropdown("dateOpen")} className={`filter-btn ${dropdownState.dateOpen ? "open" : ""}`}>
                Date
              </button>
              {dropdownState.dateOpen && (
                <>
                  <DatePicker selected={selectedDate[0]}
                    onChange={(update) => {
                      if (Array.isArray(update) && update.length === 2) { setSelectedDate(update); }
                    }}
                    dateFormat="dd/MM/yyyy" inline selectsRange startDate={selectedDate[0]} endDate={selectedDate[1]} 
                    className="projectFilterCalender"  calendarClassName="custom-calendar"/>
                  
                  <button className="clear-date-btn" onClick={() => setSelectedDate([null, null])} >
                    Clear Date
                  </button>

                </>
              )}
            </div>
          
          </div>

          <div className="task-header">
            <div className="search-container">
              <input type="text" placeholder="Enter Project Name to Search..." className="search-bar" value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />

              <button className="new-project-btn" onClick={handleNewProjectClick}>
                <img src="/images/add.png" alt="icon" className="btn-icon" /> New
                Project
              </button>
            </div>

            <div className="label-table-container">
              <table className="label-table">
                <thead>
                  <tr>
                    <th>
                      <img src="/images/briefcase.png" alt="Projects Icon" className="label-icon" />
                      <span>Projects</span>
                    </th>
                    <th>
                      <img src="/images/date.png" alt="Date Icon" className="label-icon" />
                      <span>Date</span>
                    </th>
                    <th>
                      <img src="/images/time.png" alt="Time Icon" className="label-icon" />
                      <span>Time</span>
                    </th>
                    <th>
                      <img src="/images/worker.png" alt="Tasks Icon" className="label-icon" />
                      <span>Tasks</span>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>

            <div className="task-container">
              {currentProjects.length === 0 ? (
                <div className="no-results">No projects found </div>
              ) : (
                <table className="task-table">
                  <tbody>
                    {currentProjects.map((project, index) => (
                      <tr key={index}>
                        <td className="project-name-td">{project.projectName} </td>
                        
                        <td><span className="dateRangeBGClass">{project.dateRange}</span></td>
                        
                        <td className="project-time-td">{project.time}</td>
                        
                        <td className="project-task-td">{project.mainTask}</td>
                        
                        <td>
                          <button onClick={() => handleProjectDetailsClick(project.projectId)}>
                            <img src="/images/arrow.png" alt="Next Icon" className="next-proj" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div> 
          
          </div>
        
        </div>
        
        <div className="projectpagination">
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  className={`page-button ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="next-button">
                Next
              </button>
        </div>
          <Footer />
    </div>
  );
};

export default Projects;
